module.exports = __webpack_public_path__ + "static/img/client-8.490816c6.png";